import { createContext, useContext, useState, useEffect } from 'react'
import { translations } from '../i18n/translations'

const LanguageContext = createContext()

export const LANGUAGES = [
  { code: 'en', label: 'English',  flag: '🇬🇧', dir: 'ltr', font: 'Poppins' },
  { code: 'ar', label: 'العربية', flag: '🇦🇪', dir: 'rtl', font: 'Noto Sans Arabic' },
  { code: 'hi', label: 'हिन्दी',   flag: '🇮🇳', dir: 'ltr', font: 'Noto Sans Devanagari' },
  { code: 'ru', label: 'Русский',  flag: '🇷🇺', dir: 'ltr', font: 'Poppins' },
  { code: 'zh', label: '中文',     flag: '🇨🇳', dir: 'ltr', font: 'Noto Sans SC' },
  { code: 'fr', label: 'Français', flag: '🇫🇷', dir: 'ltr', font: 'Poppins' },
  { code: 'de', label: 'Deutsch',  flag: '🇩🇪', dir: 'ltr', font: 'Poppins' },
]

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('vh_lang') || 'en')

  const langMeta = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0]
  const isRTL = langMeta.dir === 'rtl'

  useEffect(() => {
    localStorage.setItem('vh_lang', lang)
    document.documentElement.dir = langMeta.dir
    document.documentElement.lang = lang
  }, [lang, langMeta])

  function t(path) {
    const keys = path.split('.')
    let val = translations[lang]
    for (const k of keys) {
      if (!val) break
      val = val[k]
    }
    if (val !== undefined) return val
    // Fallback to English
    let fallback = translations['en']
    for (const k of keys) {
      if (!fallback) break
      fallback = fallback[k]
    }
    return fallback ?? path
  }

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, isRTL, langMeta }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  return useContext(LanguageContext)
}
